import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";
import mergeDeep from "../util/mergeDeep";
import { orderByPropertyName } from "../util/orderBy";
import generateGuid from "../util/guid";

export default function adresGatewayReducer(state = initialState.adressen, action) {
	switch (action.type) {
		case types.GEMEENTEN_LOADED: {
			let adressenData = {};

			adressenData['gemeenten'] = action.body.map(gemeente => ({ ...gemeente,
				key: `${gemeente.nis}${gemeente.postCode}${gemeente.hoofdGemeente}`,
				value: generateGuid(),
				label: gemeente.displayName }));

			adressenData['gemeenten'] = orderByPropertyName(adressenData['gemeenten'], 'displayName');

			return mergeDeep({}, adressenData);
		}

		default:
			return state;
	}
}
